import { Info } from '@tempo-io/sui-icons';
import { Tooltip, TooltipContent, TooltipTrigger } from '@tempo-io/sui-tooltip';
import { useTranslation } from 'react-i18next';
import { DeadlineRiskMessage } from './DeadlineRiskMessage';
import { getIsDeadlineAtRisk } from './lib/getIsAtRisk';

export const AtRiskInfoIcon = ({
  forecastedFinish,
  deadline,
  sourceItemName,
}: {
  forecastedFinish: string | null | undefined;
  deadline: string | null | undefined;
  sourceItemName: string | null | undefined;
}) => {
  const { t } = useTranslation();

  if (!getIsDeadlineAtRisk({ forecastedFinish, deadline })) return null;

  return (
    <Tooltip>
      <TooltipTrigger
        className="flex items-center"
        aria-label={t(($) => $.loopVisualization.timelineTooltip.atRisk)}
      >
        <Info className="w-3.5 h-3.5 text-text-error" />
      </TooltipTrigger>
      <TooltipContent className="max-w-60">
        <DeadlineRiskMessage
          forecastedFinish={forecastedFinish}
          deadline={deadline}
          sourceItemName={sourceItemName}
        />
      </TooltipContent>
    </Tooltip>
  );
};
